import { useState, useCallback } from "react";
import { QUESTION_GETTER } from "../../Utils/apis";

const useFetchQuestion = () => {
  const [loading, setLoading] = useState(false);
  const [question, setQuestion] = useState({});
  const [error, setError] = useState(null);
  const [isExpired, setIsExpired] = useState(false);

  const fetchQuestion = useCallback(async (applicantId, jobId) => {
    setLoading(true);
    setError(null);
    setIsExpired(false);

    try {
      if (!applicantId || !jobId) {
        throw new Error("Applicant ID or Job ID is missing.");
      }

      const response = await fetch(QUESTION_GETTER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ applicantId, jobId }),
      });

      const json = await response.json();

      if (response.ok && json?.status === "SUCCESS" && json?.data) {
        setQuestion(json.data);
        return { ok: true, data: json.data };
      }

      const message = String(
        json?.details || json?.message || json?.error || "",
      ).toLowerCase();

      const expiredMessage = String(json?.data?.Status || "").toLowerCase();

      if (response.status === 400 && expiredMessage === "link expired") {
        setIsExpired(true);
        return { ok: false, expired: true };
      }

      if (
        response.status === 400 &&
        (message === "interview done" || message === "process completed")
      ) {
        return { ok: false, interviewDone: true };
      }

      throw new Error(
        json?.message ||
          json?.details ||
          json?.error ||
          `Failed to fetch question (HTTP ${response.status}).`,
      );
    } catch (err) {
      setError(err.message || "Failed to fetch interview questions.");
      return { ok: false, error: err.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return [loading, error, question, fetchQuestion, isExpired];
};

export default useFetchQuestion;
